export default function isNullOrUndefined(o: Object) {
    return o === undefined || o === null;
}
